import Content from '@nrdy-marketing-engine/components/src/content';
import { useInterpolation } from '@nrdy-marketing-engine/interpolation';
import { PanelData, PanelStateProps } from '../../@types/panel-data';
import BackButton from '../back-button';
import ContinueButton from '../continue-button';

interface ContentPanelProps extends PanelData, PanelStateProps {
  _modelApiKey: 'panel_content';
}

/**
 * A panel that renders simple content without form controls.
 */
function ContentPanel({
  headline,
  content,
  continueButton,
  backButton,
  onBack,
  onNext,
}: ContentPanelProps) {
  return (
    <div className="mb-auto">
      <Content className="prose-lg" heading={useInterpolation(headline)} headingLevel={2}>
        {useInterpolation(content)}
      </Content>
      {continueButton && <ContinueButton onClick={onNext} text={continueButton.text} />}
      {backButton && <BackButton onClick={onBack} text={backButton.text} />}
    </div>
  );
}

export default ContentPanel;
